import { Routes } from '@angular/router';

import { SaleTermsComponent } from './sale-terms/sale-terms.component';
import { PurchaseTermsComponent } from './purchase-terms/purchase-terms.component';

export const NetTermsRoutes: Routes = [
    {

        path: '',
        children: [ {
            path: 'sale-terms',
            component: SaleTermsComponent
        },
        {
            path: 'purchase-terms',
            component: PurchaseTermsComponent
        }]
    }
]